import { getDisplayValue } from "../../formatting/string-manipulation";
import type { Pillars } from "../../types";
import type { Field } from "../tabs/types";

const benefitPillars = [
  { key: "carbon", label: "Carbon" },
  { key: "biodiversity", label: "Biodiversity" },
  { key: "people", label: "People" },
] as const;

export function buildBenefitsFields(
  pillars?: Pillars,
  startIndex = 0,
): Array<Field> {
  return benefitPillars.flatMap(({ key, label }, pillarIndex): Array<Field> => {
    const benefits = pillars?.[key]?.benefits;
    const fieldIndex = startIndex + pillarIndex * 2;

    return [
      {
        name: `${label}: quantity`,
        type: "text",
        index: fieldIndex,
        value: getDisplayValue(benefits?.quantity),
      },
      {
        name: `${label}: description`,
        type: "text",
        index: fieldIndex + 1,
        value: getDisplayValue(benefits?.description),
      },
    ];
  });
}
